import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-582031a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_2 = { class: "table table-hover align-top mt-4" }
const _hoisted_3 = { class: "border-dark border-bottom pb-2" }
const _hoisted_4 = { class: "border-dark border-bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  colspan: 4,
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_9 = { class: "status" }
const _hoisted_10 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_11 = ["onClick", "data-dp-tooltip"]
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "address" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_18 = { class: "buttons" }
const _hoisted_19 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_21 = ["onClick", "data-dp-tooltip"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('deliveryPickupLocations'),
        mb: 4,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent
      }, {
        buttons: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: {name: 'delivery-pickup-location-new'},
            class: "btn btn-hover icon-link",
            "data-dp-tooltip": _ctx.$t('edit'),
            "data-dp-position": "left"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
            ]),
            _: 1
          }, 8, ["data-dp-tooltip"])
        ]),
        _: 1
      }, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('address')), 1),
            _hoisted_6
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!_ctx.pageUI.isReady)
            ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                key: 0,
                "n-cols": 4
              }))
            : (!_ctx.hasLocations)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('noResults')), 1)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.locations, (location) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: location.id
                  }, [
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("i", {
                          onClick: _withModifiers(($event: any) => (_ctx.updateStatus(location.id, location.status.code === _ctx.StatusEnum.PUBLISHED ? _ctx.StatusEnum.NOT_PUBLISHED : _ctx.StatusEnum.PUBLISHED)), ["prevent"]),
                          class: _normalizeClass(["mas mas-fill-1", [location.status.code === _ctx.StatusEnum.PUBLISHED ? 'text-success' : 'text-danger', 'cu-p']]),
                          "data-dp-tooltip": location.status.code === _ctx.StatusEnum.PUBLISHED ? _ctx.$t('published') : _ctx.$t('notPublished')
                        }, " circle ", 10, _hoisted_11)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(location.location.description), 1)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      (location.address)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", null, _toDisplayString(location.address.street) + " " + _toDisplayString(location.address.house_number) + _toDisplayString(location.address.box ? (', ' + location.address.box) : ''), 1),
                            (location.address.extra_address_line)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(location.address.extra_address_line), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, _toDisplayString(location.address.postal_code) + " " + _toDisplayString(location.address.city_name), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('noAddress')), 1))
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_router_link, {
                          to: {name: 'delivery-pickup-location-edit', params: {id: location.id}},
                          class: "btn btn-icon btn-primary ms-2",
                          "data-dp-tooltip": _ctx.$t('edit'),
                          "data-dp-position": "left"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20
                          ]),
                          _: 2
                        }, 1032, ["to", "data-dp-tooltip"]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.deleteLocation(location.id)),
                          class: "btn btn-icon btn-danger ms-2",
                          "data-dp-tooltip": _ctx.$t('delete'),
                          "data-dp-position": "left"
                        }, _hoisted_23, 8, _hoisted_21)
                      ])
                    ])
                  ]))
                }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}